import { Button, Stack, Typography, Container } from "@mui/material";
import { useModal } from "../../../../hooks/useModal";
import { Popup } from "../../../Popup/Popup";
import FinalScorePopup from "./FinalScorePopup";

interface Props {
  finalScore: number,
  scores: number[]
}


const FinalScore = ({ finalScore, scores }: Props) => {
  const { isShown: showPopup, toggle: togglePopup } = useModal();


  return (
    <Stack>
      {/* 
      <Button variant="contained" style={{ "flexDirection": "column", "height": "90px", "width": "100%", "textAlign": "center" }} onClick={togglePopup}>
      */} 
      <Container className="font-list no-border">
        <Typography variant="h4" className="font-list font-score">
          {finalScore}
        </Typography>
        <Typography  className="font-list">
          points
        </Typography>
      {/*
      </Button>
      */}
      </Container>
      <Popup
        isShown={showPopup}
        hide={togglePopup}
        headerText={"Sommaire du jeu"}
        modalContent={<FinalScorePopup scores={scores} />}
      />
    </Stack>
  );
};


export default FinalScore;